import * as React from 'react'
import { fromJSX } from 'widgets-for-react'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { DP } from '../../../drupal/blockDefinitions'
import { textImageCompactSrc, textImageCompactSrcSet, textImageSrc, textImageSrcSet } from '../../../drupal/utils/imageSizes'
import { parseDrupalImageUrls } from '../../../drupal/utils/modernImage'
import { dummyData, randomTitle, randomWords, randomWysiwygText } from '../../../utils/dummyData'
import { linkWrapper } from '../../../utils/link'
import { ModernBlock, SeoEvent } from '../../modernBlocks.state'
import { imageTextBlockClasses, ImageTextBlockLayout } from './imageTextBlock.layout'
import { ImageTextBlockProps } from './imageTextBlock.state'

export const imageTextBlock: ModernBlock<ImageTextBlockProps, any, any, DP.ImageText> = {
  kind: 'imageTextBlock',
  render: (setRootState, rootState, blockIndex, blockProps, amountNested) =>
    fromJSX((updateBlock) => (
      <ImageTextBlockLayout.Inner
        amountNested={amountNested!}
        imageDirection={blockProps.imageDirection}
        displayCompact={blockProps.displayCompact}
      >
        <ImageTextBlockLayout.Content
          label={blockProps.label}
          title={blockProps.title}
          intro={blockProps.intro}
          text={blockProps.text}
          showPrimary={blockProps.showPrimary}
          showSecondary={blockProps.showSecondary}
          primaryAction={blockProps.primaryAction!}
          secondaryAction={blockProps.secondaryAction!}
          showActionAsLink={blockProps.showActionAsLink}
          displayCompact={blockProps.displayCompact}
        />
        <ImageTextBlockLayout.Visual
          image={blockProps.image}
          imageDirection={blockProps.imageDirection}
          displayCompact={blockProps.displayCompact}
        />
      </ImageTextBlockLayout.Inner>
    )),
  blockClassName: (props) => `
    ${getClassNameModern(imageTextBlockClasses, 'block', 'mb-6')}
    ${getClassNameModern(imageTextBlockClasses, props.imageDirection == 'left' ? 'blockLeft' : 'blockRight', '')}
    ${props.displayCompact == true ? 'compact' : 'default'}
  `,
  inView: {
    threshold: 0.75,
    triggerOnce: false,
    showAs: 'section',
    inViewClassName: 'inview',
    updateState: (currentInviewState, currentBlockState) => {
      return {
        ...currentBlockState,
        inviewState: currentInviewState,
      }
    },
  },
  adapters: {
    drupal: (dpBlock: DP.ImageText, blockIndex: number) => {
      const targetId = dpBlock.target.type[0].target_id
      if (targetId != 'text_with_image') return undefined
      const displayCompact = dpBlock.target.field_display[0]?.value == true ? true : false
      const fieldMediaImage = dpBlock.target.field_image[0]?.target.field_media_image[0]
      const fieldMediaSource = dpBlock.target.field_image[0]?.target.field_source[0]
        ? dpBlock.target.field_image[0]?.target.field_source
        : undefined
      const dpImages = fieldMediaImage
        ? parseDrupalImageUrls(
            fieldMediaImage,
            fieldMediaSource,
            displayCompact == true ? textImageCompactSrcSet : textImageSrcSet,
            displayCompact == true ? textImageCompactSrc : textImageSrc
          )?.image
        : undefined
      return {
        label: dpBlock.target.field_label ? dpBlock.target.field_label[0]?.value : undefined,
        excludeFromPageMenu: dpBlock.target?.field_exclude_from_page_menu ? dpBlock.target.field_exclude_from_page_menu?.[0]?.value : undefined,
        title: dpBlock.target.field_title ? dpBlock.target.field_title[0]?.value : undefined,
        intro: dpBlock.target.field_introduction ? dpBlock.target.field_introduction[0]?.value : undefined,
        text: dpBlock.target.field_body[0]?.processed,
        anchorTitle: dpBlock.target.field_title ? dpBlock.target.field_title[0]?.value : `anchor title text block ${dpBlock.target_id}`,
        imageDirection: dpBlock.target.field_featured_content_direction[0]?.value == 'image_right' ? 'right' : 'left',
        image: dpImages,
        showPrimary: dpBlock.target.field_links[0] ? true : false,
        showSecondary: dpBlock.target.field_links[1] ? true : false,
        primaryAction: linkWrapper({
          title: dpBlock.target?.field_links ? dpBlock.target?.field_links[0]?.title! : '',
          url: dpBlock.target?.field_links ? dpBlock.target?.field_links[0]?.processed_url! : '',
          anchor: dpBlock.target?.field_links ? dpBlock.target?.field_links[0]?.options?.attributes?.id! : '',
        }),
        secondaryAction: linkWrapper({
          title: dpBlock.target?.field_links ? dpBlock.target?.field_links[1]?.title! : '',
          url: dpBlock.target?.field_links ? dpBlock.target?.field_links[1]?.processed_url! : '',
          anchor: dpBlock.target?.field_links ? dpBlock.target?.field_links[1]?.options?.attributes?.id! : '',
        }),
        showActionAsLink: dpBlock.target.field_link_type[0]?.value == true ? true : false,
        displayCompact: displayCompact,
      }
    },
  },
  seoEvents: (props, blockIndex) =>
    [
      props.primaryAction
        ? {
            id: `primary_button`,
            event: 'onClick',
            category: 'text_with_image',
            label: window.location.pathname,
            action: 'primary_' + props.primaryAction.title,
          }
        : undefined,
      props.secondaryAction
        ? {
            id: `secondary_button`,
            event: 'onClick',
            category: 'text_with_image',
            label: window.location.pathname,
            action: 'secondary_' + props.secondaryAction.title,
          }
        : undefined,
    ].filter((i) => i != undefined) as SeoEvent[],
  sampleExample: [
    {
      label: randomWords(),
      title: randomTitle(),
      text: randomWysiwygText(),
      imageDirection: 'left',
      image: dummyData.image,
      showPrimary: true,
      showSecondary: true,
      primaryAction: dummyData.primaryButton,
      secondaryAction: dummyData.secondaryButton,
      anchorTitle: 'imagetext-sample-1',
      showActionAsLink: false,
      displayCompact: false
    },
    {
      title: randomTitle(),
      text: randomWysiwygText(),
      intro: dummyData.intro,
      imageDirection: 'right',
      image: dummyData.image,
      showPrimary: true,
      showSecondary: false,
      primaryAction: dummyData.primaryButton,
      anchorTitle: 'imagetext-sample-2',
      showActionAsLink: true,
      displayCompact: true
    },
  ],
}
